import { useMemo } from "react";

import { useDataLayerQuery } from "#/hooks/useDataLayer";

import { BreedingValuesRankService } from "./BreedingValuesRankService";

/**
 * Custom hook for Breeding Values Rank Query.
 * Uses the BreedingValuesRankService to perform POST queries.
 *
 * @returns {object} The data layer query object (result, isLoading, error, query, reload).
 */
export function useBreedingValuesRankQuery() {
  const service = useMemo(() => new BreedingValuesRankService(), []);

  return useDataLayerQuery({
    ident: "breeding-values-rank",
    dataLayer: service,
  });
}
